import { render, staticRenderFns } from "./epaper-id.vue?vue&type=template&id=7ad0c44e&"
import script from "./epaper-id.vue?vue&type=script&lang=js&"
export * from "./epaper-id.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports